import {
  Client,
  DetailedClient,
  ClientFilters,
  QueryResult,
} from '@/type';
import api from '@/API';

export default {
  findAll(
    customerId: number,
    filters:ClientFilters = {},
    fields: string[] = [],
  ): Promise<QueryResult<Client>> {
    const params = Object.assign(filters, { fields: fields.join(',') || undefined });
    return api
      .get(`customers/${customerId}/clients`, { params })
      .then(response => response.data);
  },
  find(id: number): Promise<DetailedClient> {
    return api.get(`clients/${id}`).then(response => response.data);
  },
  count(customerId: number): Promise<number> {
    return this
      .findAll(customerId, { limit: 1 })
      .then((result: QueryResult) => result.total);
  },
};
